let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7VuUY")).then(() => parcelRequire('bFrp8'));